module.exports = __webpack_public_path__ + "img/homepage-content-image-honda.c3903aa1.jpg";